"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var variables_1 = require("../../../../../../style/variables");
var Text_1 = __importDefault(require("../../../../../Text"));
var styles_1 = require("../../../../Badge/styles");
var spacingStyle = react_1.css({
    padding: '2px 8px 2px 8px',
    gap: 4,
});
var Badge = function (_a) {
    var children = _a.children;
    var badgeStyle = react_2.useMemo(function () { return styles_1.createBadgeStyle("var(" + variables_1.RootColor.White + ")", "var(" + variables_1.RootColor.Gray.DARK_2 + ")"); }, []);
    return (react_1.jsx(Text_1.default, { color: "inherit", size: 12, weight: 500, css: [badgeStyle, spacingStyle] }, children ? react_1.jsx("span", null, children) : null));
};
exports.default = Badge;
